module.exports = __webpack_public_path__ + "static/media/polar-bear-cubs.9ae4a12e.png";